import { useQuery } from '@tanstack/react-query';
import {
  fetchProductionDashboardStats,
  fetchProductionMaterialSummary,
  fetchProductionMaterialTotals,
  fetchRemainingMaterialSummary,
  fetchFinalPhaseTokens
} from '../api/jobsApi';

export function useProductionDashboardStats() {
  return useQuery({
    queryKey: ['production-dashboard-stats'],
    queryFn: fetchProductionDashboardStats,
    refetchInterval: 10000
  });
}

export function useProductionMaterialSummary() {
  return useQuery({
    queryKey: ['production-dashboard', 'material-summary'],
    queryFn: fetchProductionMaterialSummary,
    refetchInterval: 10000,
    staleTime: 5000
  });
}

export function useProductionMaterialTotals() {
  return useQuery({
    queryKey: ['production-dashboard', 'material-totals'],
    queryFn: fetchProductionMaterialTotals,
    refetchInterval: 10000,
    staleTime: 5000
  });
}

export function useRemainingMaterialSummary() {
  return useQuery({
    queryKey: ['orders', 'remaining-material-summary'],
    queryFn: fetchRemainingMaterialSummary,
    refetchInterval: 10000,
    staleTime: 5000
  });
}

export function useFinalPhaseTokens() {
  return useQuery({
    queryKey: ['production-dashboard', 'final-phase-tokens'],
    queryFn: fetchFinalPhaseTokens,
    refetchInterval: 5000,
    staleTime: 3000
  });
}
